import { useQuery } from "@tanstack/react-query";
import { odataFetchBlob } from "../../lib/odata-fetch";
import { documentsKeys } from "./documents-keys";

export function useFile(id?: string | null) {
  const { data, ...query } = useQuery({
    queryKey: documentsKeys.getFile(id!),
    queryFn: ({ meta }) => fetchFile(id!, meta!.token!),
    staleTime: Infinity,
    enabled: () => !!id,
  });

  return {
    fileUrl: data,
    ...query,
  };
}

export async function fetchFile(id: string, token: string) {
  const blob = await odataFetchBlob({ token, path: `File(${id})/$value` });

  return URL.createObjectURL(blob);
}
